<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-swim-pants`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4a2 2 0 012 2v10h-.034l3.957 23.211a4.1 4.1 0 01-3.353 4.73 6.308 6.308 0 01-.343.044c-.086.008-.172.01-.345.015H29.16a4.1 4.1 0 01-3.846-2.676l-1.328-3.588-1.34 3.596A4.1 4.1 0 0118.804 44H6.118a4.1 4.1 0 01-4.1-4.1 6.69 6.69 0 01.015-.346 6.34 6.34 0 01.044-.343L6.032 16H6V6a2 2 0 012-2h32zm-2.091 12H10.091L6.02 39.883l-.002.017a.1.1 0 00.1.1h12.687a.1.1 0 00.093-.065l4.162-11.163a1 1 0 011.875.002l4.132 11.16a.1.1 0 00.093.066h12.722l.016-.001a.1.1 0 00.082-.116L37.909 16zM9.999 8h28v4H10V8z"/></svg>
</template>
<script>

export default {
  name: 'IconSwimPants',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
